// extracted by mini-css-extract-plugin
export default {"heading":"SelectFile_heading__kl5sw","text":"SelectFile_text__kEg5g","downloadLink":"SelectFile_downloadLink__tumxZ"};